import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import RlCloudSandboxGrid from "../RlCloudSandboxGrid";
import { BehavioralTabsData } from "../../../@types/rldynamicanalysis";
import { RlCloudSandboxBehavioralItems } from "./RlCloudSandboxBehavioralItems";

type RlCloudSandboxBehavioralTabProps = {
  data: BehavioralTabsData | null;
};

type BehavioralTabsDataKey = keyof BehavioralTabsData;

const RlCloudSandboxBehavioralTabs = ({
  data
}: RlCloudSandboxBehavioralTabProps) => {
  const [activeTab, setActiveTab] = useState(
    RlCloudSandboxBehavioralItems.process_actions.title
  );

  const handleTabsSelect = (tabsKey: string) => {
    setActiveTab(tabsKey);
  };

  const behavioralTabItems = Object.entries(RlCloudSandboxBehavioralItems).map(
    ([key, value]) => {
      const { title, schema } = value;
      return (
        <Tab
          key={title}
          eventKey={title}
          title={`${title} (${
            data?.[key as BehavioralTabsDataKey]?.length || 0
          })`}
          mountOnEnter
        >
          <RlCloudSandboxGrid
            data={data?.[key as BehavioralTabsDataKey]}
            schema={schema}
            key={key}
          />
        </Tab>
      );
    }
  );

  return (
    <Tabs
      id="rl-cloud-sandbox-behavioral-tabs"
      variant="tabs"
      activeKey={activeTab}
      onSelect={handleTabsSelect}
      className="rlbs"
      transition={false}
    >
      {behavioralTabItems}
    </Tabs>
  );
};

export default RlCloudSandboxBehavioralTabs;
